import { SystemEvents } from '@repo/alt/Services/constants/SystemEvents.js'

import { useCartModule } from '../composables/useCartModule'

export default defineNuxtPlugin({
  name: 'cart-root',
  dependsOn: ['auth-loader:plugin'],
  async setup(nuxtApp) {
    const { support: authSupport } = useAuth()
    const { support } = useCartModule()
    const bus = useBus()

    /* Если есть хоть какая-то сессия, даже анонимная, то загружаем корзину */
    if (authSupport.checkAuth()) {
      await support.loadCart()
    }

    if (import.meta.client) {
      bus.on(SystemEvents.LOGGED_IN, () => {
        support.loadCart(true)
      })

      bus.on(SystemEvents.ORDER_CREATED, () => {
        support.loadCart(true)
      })
    }
  },
})
